import React, { useEffect, useState } from "react";
import FormHeader from "../../components/PublicLayer/FormHeader";
import PublicSection from "../../components/PublicLayer/PublicSection";
import useForm, { Form } from "../../components/controls/useForm";
import FormLabel from "../../components/HtmlMarkup/FormLabel";
import Controls from "../../components/controls/control";
import { Link, useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../features/Auth/authApi";
import ErrorMessage from "../../components/Ui/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { userLogOut } from "../../features/Auth/authSlice";

const initializeValue = {
  email: "",
  password: "",
};
export default function StudentLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [login, { isSuccess, isError, error }] = useLoginMutation();
  const { values, handleInputChange, resetForm } = useForm(initializeValue);
  const [errors, setErrors] = useState(false);
  useEffect(() => {
    if (isSuccess) {
      if (auth?.user?.role === "student") {
        resetForm(initializeValue);
        navigate("/coursePlayer");
      } else {
        localStorage.clear();
        dispatch(userLogOut());
        setErrors("Email or password not matched !!");
      }
    } else if (isError) {
      setErrors(error.data);
    }
  }, [isSuccess, isError]);
  const handleSubmit = (e) => {
    e.preventDefault();
    login(values);
  };
  return (
    <PublicSection>
      <FormHeader title={"Sign in to Student Account"} />
      <Form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <FormLabel htmlFor="email-address" className="sr-only">
              Email address
            </FormLabel>
            <Controls.Input
              id="email-address"
              name="email"
              type="email"
              autocomplete="email"
              className="login-input rounded-t-md"
              placeholder="Email address"
              value={values.email}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <FormLabel htmlFor="password" className="sr-only">
              Password
            </FormLabel>
            <Controls.Input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              className="login-input rounded-b-md"
              placeholder="Password"
              value={values.password}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {errors && <ErrorMessage error={errors} />}

        <div className="flex items-center justify-end">
          <div className="text-sm">
            <Link
              to="/StudentReistration"
              className="font-medium text-violet-600 hover:text-violet-500"
            >
              Create New Account
            </Link>
          </div>
        </div>

        <div>
          <Controls.Button
            type="submit"
            text="Sign in"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          />
        </div>
      </Form>
    </PublicSection>
  );
}
